import React from "react";
import investingMadeSimple from "../../assets/images/Investing-Made-Simple-white.svg";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import {
  faSquareFacebook,
  faSquareTwitter,
  faSquareYoutube,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/pro-solid-svg-icons";

interface FooterProps {
  props?: any;
}

const Footer = ({ props }: FooterProps) => {
  return (
    <>
      <div className="bg-[#164A7C] text-white w-full ">
        <div className="flex items-center justify-center w-full">
          <div className="relative w-full max-w-screen-xl mx-auto">
            <div className="absolute left-1/2 transform -translate-x-1/2 -top-[25px] py-2 px-2 xs:px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24  bg-white border-[0.5px] border-black rounded-[15px]">
              <div className="flex flex-col items-center justify-center h-full">
                <div className="flex flex-col items-center justify-center">
                  <span className="text-black font-bold text-lg -mb-2">
                    INVEST IN
                  </span>
                  <span className="font-extrabold text-lg text-[#164A7C] text-center">
                    AMERICAN REAL ESTATE
                  </span>
                </div>
                <div className="my-2.5">
                  <a
                    href="https://securedinvestmentcorp.com/investment-opportunities/"
                    className="btn btn-accent btn-sm text-white text-xs font-bold px-4 rounded-[4px]"
                  >
                    BROWSE INVESTMENTS
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center w-full my-8 pt-24">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            <div className="w-72">
              <img
                src={investingMadeSimple}
                alt="logo"
                className="w-[290px] "
              />
            </div>
            <div className="flex flex-col columns-1 text-sm w-72 px-12">
              <div className="mb-5">
                <span className="font-extrabold text-lg">RESOURCES</span>
              </div>
              <div className="flex flex-col">
                <a href="https://securedinvestmentcorp.com/faqs/">FAQs</a>
                <a href="https://securedinvestmentcorp.com/loan-guides-summary/">
                  Loan Guides Summary
                </a>
                <a href="https://securedinvestmentcorp.com/about-us/">
                  About Us
                </a>
                <a href="https://securedinvestmentcorp.com/meet-the-team/">
                  Meet The Team
                </a>
                <a href="https://securedinvestmentcorp.com/blog/">Resources</a>
                <a href="https://hesthesolution.com/bibles/?__hstc=59566066.cf3d398fa9304e2f9c807b43c19fdd98.1726004837028.1728572544147.1728665994188.33&__hssc=59566066.1.1728665994188&__hsfp=3134180813">
                  Request Free Bible
                </a>
              </div>
            </div>
            <div className="flex flex-col columns-1 gap-2 w-72">
              <div className="mb-5">
                <span className="font-extrabold text-lg">CONTACT US</span>
              </div>
              <div className="flex flex-row items-center gap-2 text-xs">
                <FontAwesomeIcon icon={faLocationDot} />
                <a
                  href="https://www.google.com/maps/place/701+E+Front+Ave,+Coeur+d'Alene,+ID+83814/@47.6728217,-116.7786313,17z/data=!3m1!4b1!4m5!3m4!1s0x5361c65e2effec97:0x996f70800ac58e3c!8m2!3d47.6728217!4d-116.7764426?shorturl=1"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-gray-300 cursor-pointer"
                >
                  701 E. Front Ave. Coeur d'Alene, ID 83814
                </a>
              </div>
              <div className="flex flex-row items-center gap-2 text-xs">
                <FontAwesomeIcon icon={faEnvelope} />
                <a
                  href="mailto:info@securedinvestmentcorp.com"
                  className="hover:text-gray-300 cursor-pointer"
                >
                  info@securedinvestmentcorp.com
                </a>
              </div>
              <div className="flex flex-row items-center gap-2 text-xs">
                <FontAwesomeIcon icon={faPhone} className=" " />
                <a
                  href="tel:8009875988"
                  className="hover:text-gray-300 cursor-pointer"
                >
                  (800) 987-5988
                </a>
              </div>
              <div className="flex flex-row items-center gap-3 mt-2">
                <a
                  href="https://www.facebook.com/SecuredInvestmentCorp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faSquareFacebook}
                    className="text-[22px]"
                  />
                </a>
                <a
                  href="https://x.com/SecInvCorp"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faSquareTwitter}
                    className="text-[22px]"
                  />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCqt5ZGO0uUTEjYPr9pTGEFA"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon
                    icon={faSquareYoutube}
                    className="text-[22px]"
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/secured-investment-corp/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faLinkedin} className="text-[22px]" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col columns-1 items-center justify-center gap-2 mb-10 text-xs text-center">
          <div>
            NMLS #1760709 | Arizona Mortgage Broker License #0950084 |
            California Finance Lenders License 60DBO-101344
          </div>
          <a
            href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/1760709"
            className="hover:text-gray-300"
          >
            Please click here for the Secured Investment Corp NMLS Consumer
            Access Page
          </a>
        </div>
      </div>
      <div className="bg-[#123B63] text-white text-xs pt-8 px-2  md:px-24 xl:px-80 w-full">
        <div>
          <p>
            Secured Investment Corp and its members, officers, directors,
            owners, employees, agents, representatives, suppliers and service
            providers provides this website for informational purposes only. By
            using this site, you are subject to our Terms of Use and our Privacy
            Policy. <b>Please read these carefully before proceeding.</b> In
            exchange for using the newsletter, you agree not to hold Secured
            Investment Corp, our affiliates or any third party service provider
            liable for any possible claim for damages arising from any decision
            you make based on information or other content made available to you
            through this site.
          </p>
          <br></br>
          <p>
            Neither Secured Investment Corp. nor any of its affiliates are
            registered investment advisors or broker-dealers, nor do they
            provide tax or financial advice and do not represent in any manner
            that the outcomes described herein will result in any particular tax
            or financial consequence.
          </p>
          <br></br>
          <p>
            THERE IS NO ASSURANCE THAT ANY STRATEGY WILL SUCCEED OR THAT ANY
            PROGRAM WILL MEET ITS INVESTMENT OBJECTIVES.
          </p>
          <br></br>
          <p>
            All investments contain risk and may lose value, and any investment
            with Secured Investment Corp is considered speculative. There are no
            guarantees of distributions or returns, and an investor may lose all
            or a part of their investment. Past performance is no guarantee of
            results, and any historical returns, target returns, expected
            returns, disclosed rates of return, disclosed earnings statements,
            or probability projections may not reflect actual future
            performance. Investors should not rely on forward-looking statements
            because such statements are inherently uncertain and involve risks.
            Any reliance on figures presented is done so at the investor’s own
            risk. Secured Investment Corp cannot guarantee that investors will
            achieve similar returns as prior investors.
          </p>
          <br></br>
          <p>
            Secured Investment Corp encourages investors to invest carefully.
            All investors are advised to fully understand all risk associated
            with any investment the investor may choose to make. Accordingly,
            you should consult with your own attorneys, accountants, and other
            professional advisors prior to making an investment.
          </p>
          <br></br>
          <p>
            Nothing in this message or accompanying links shall constitute an
            offer to sell securities. Any such offer shall be made solely
            pursuant to a separate Private Placement Memorandum or Offering
            Circular (the presentation of which is dependent on the Fund that is
            being targeted for investment). The information on this website
            presents a general summary of the business, the various funds, and
            the purpose and principal business terms of an investment in various
            funds. These summaries do not purport to be complete and are
            qualified in their entirety by reference to the more detailed
            discussion contained in the Private Placement Memorandum and/or
            Offering Circular.
          </p>
          <br></br>
          <p>
            Secured Investment High Yield Fund II, LLC, and Secured Investment
            Fixed Income Fund V LLC are open to “accredited investors” only,
            through offerings made in accordance with Regulation D, Rule 506(c)
            of the Securities Act of 1933, as amended. In purchasing securities
            through a 506(c) offering, we are obligated to verify any
            participating investor’s status as an “accredited investor” in
            accordance with Rule 501 of Regulation D.
          </p>
          <br></br>
          <p>
            Circle of Wealth Fund III LLC has filed offering circulars and may
            additionally post-qualification amendments (including supplements to
            such filings) with the Securities and Exchange Commission (the
            “SEC”) covering the current offering of membership interests. An
            investment in membership interests entails risk of loss, and you may
            lose all or part of your investment. Each investor should carefully
            consider the risk factors and other information discussed in the
            qualified offering circulars/PQAs (and current supplements, if any)
            before purchasing membership interests. For more information on the
            Risk Factors and Cautionary Notes of investing with Circle of Wealth
            Fund III LLC, please click here:
            <a href="http://las.cogo.membership.site.s3.amazonaws.com/COW/COWIII-RISK-FACTORS.pdf">
              http://las.cogo.membership.site.s3.amazonaws.com/COW/COWIII-RISK-FACTORS.pdf
            </a>
          </p>
          <br></br>
          <p>
            Offerings by Circle of Wealth Fund III LLC: The Offering Circular is
            available here:
            https://www.sec.gov/Archives/edgar/data/1762825/000173112220000349/e1852partiiandiii.htm
          </p>
          <br></br>
          <p>
            Neither the SEC nor any state securities commission or regulatory
            authority approved, disapproved, endorsed, or recommended the merits
            of the offering described in an Offering Circular, Private Placement
            Memorandum, or reflected on this website.
          </p>
          <p>
            Manager’s and/or Company’s services do not constitute “crowdfunding”
            as described in Title III of the Footer 3e Jumpstart Our Business
            Startups Act (“JOBS Act”).
          </p>
          <br></br>
          <p>
            Any properties, photos, “Investor Win” summaries, and/or investment
            results shown are not a representative sample of the portfolio of
            properties owned and/or originated by the Company. Accordingly, no
            conclusions or inferences about the overall portfolio of assets held
            can or should be drawn from these illustrative examples. However,
            these are past transactions conducted and underwritten by the
            Secured Investment Corp management team.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 items-center justify-between mt-12 mb-14">
          <p>Copyright © {new Date().getFullYear()}. All rights reserved.</p>
          <div className="flex flex-row  items-center justify-center gap-1">
            <a href="https://securedinvestmentcorp.com/earnings-disclaimer/">
              Earnings Disclaimer
            </a>
            <span>|</span>
            <a href="https://securedinvestmentcorp.com/privacy-policy/">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="https://securedinvestmentcorp.com/terms-of-use/">
              Terms of Use
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
